import LOVABLE_INSPIRATION_PAGES from './lovable-inspiration-pages.json';

const lovableUrlsByBlueprintId: Record<string, string> = LOVABLE_INSPIRATION_PAGES;

export const getLovableUrlForBlueprint = (blueprintId: string): string | undefined =>
  lovableUrlsByBlueprintId[blueprintId];
